import { API_URL } from "./../../utils/api-utils";

export const url = `${API_URL.Job}/hubs/job`;
export const method = "OnJobStatusChanged"
